var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{attrs:{"modalNode":_vm.modalNode,"title":"交通模拟","id":"vehicleSimulation","close":_vm.trafficClose}},[_c('template',{slot:"content"},[_c('fixedRoute')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }